import { render, staticRenderFns } from "./SeccionesPage.vue?vue&type=template&id=6288f69a"
import script from "./SeccionesPage.vue?vue&type=script&lang=js"
export * from "./SeccionesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports